import React from "react";

import Container from 'react-bootstrap/Container';

import "./Footer.scss";

export default function Footer() {
    return (
        <footer className="site-footer">
            <Container>
                <div className="footer-top">
                    <h2 className="footer-heading">Get in Touch</h2>

                    <div className="footer-field footer-field--hours">
                        <span className="footer-label">Hours</span>
                        <p className="footer-field__primary">Tues, Wed &amp; Thurs</p>
                        <p className="footer-field__secondary">9:00am – 4:00pm</p>
                    </div>

                    <div className="footer-field footer-field--phone">
                        <span className="footer-label">Phone</span>
                        <p className="footer-field__primary">(636) 538-5422</p>
                        <p className="footer-field__secondary">Fax · (636) 206-8398</p>
                    </div>

                    <div className="footer-field footer-field--address">
                        <span className="footer-label">Address</span>
                        <p className="footer-field__primary">5757 S. Lindbergh Blvd, Suite 200</p>
                        <p className="footer-field__secondary">St. Louis, MO 63123</p>
                    </div>

                    <div className="footer-field footer-field--email">
                        <span className="footer-label">Email</span>
                        <p className="footer-field__primary">
                            <a className="footer-email-link" href="mailto:info@betterdayspractice.com">
                                info@betterdayspractice.com
                            </a>
                        </p>
                    </div>

                    <div className="footer-logo">
                        <img src="../../BetterDaysWhite.png" alt="Better Days Psychiatry and Family Practice" />
                    </div>
                </div>

                <hr className="footer-divider" />

                <div className="footer-disclaimer">
                    <span className="footer-label">Disclaimer</span>
                    <div className="footer-disclaimer-columns">
                        <p>
                            The information provided on this website is not medical advice. It is for informational and educational purposes only. We are not responsible for the accuracy of external websites linked from this site. Please contact us directly to schedule an appointment to discuss your mental health concerns, diagnoses, or treatments. If you have a medical emergency, call 911.
                        </p>
                        <p>
                            Your website-related activities and communications do not create a provider-patient relationship between you and Better Days Psychiatry and Family Practice or any of its providers, and do not create a duty for us to follow up with you. To learn about our services, please contact us directly.
                        </p>
                    </div>
                </div>
            </Container>
        </footer>
    );
}
